import { render, staticRenderFns } from "./NewEvaluation.vue?vue&type=template&id=5d5bb9a2&"
import script from "./NewEvaluation.vue?vue&type=script&lang=js&"
export * from "./NewEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports